import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * 下注表格头部组件
 * 显示交易信息和操作按钮
 */
export default function BettingHeader({ symbol, onClose }) {
  const navigate = useNavigate();
  
  const handleDetailClick = () => {
    // 提取币种符号（去除/USD后缀）
    const coinSymbol = symbol.replace('/USD', '');
    navigate(`/coin/${coinSymbol}`);
  };
  
  return (
    <div className="mb-4 flex items-center justify-between">
      {/* 左侧：交易信息 */}
      <div className="flex items-center gap-1.5 px-3 py-1.5 bg-white/10 rounded-full backdrop-blur-sm">
        <div className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse"></div>
        <span className="text-sm font-medium text-white">
          {symbol}
        </span>
      </div>

      {/* 右侧：操作按钮 */}
      <div className="flex items-center gap-2">
        {/* Detail 按钮 */}
        <button 
          onClick={handleDetailClick}
          className="px-3 py-1.5 text-xs font-medium text-white/80 bg-white/10 hover:bg-white/20 rounded-full backdrop-blur-sm transition-all duration-200 hover:scale-105"
        >
          Detail
        </button>
        
        {/* 关闭按钮 */}
        <button 
          onClick={onClose}
          className="w-8 h-8 flex items-center justify-center text-white/60 hover:text-white bg-white/10 hover:bg-white/20 rounded-full backdrop-blur-sm transition-all duration-200 hover:scale-105"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}
